import script from "./PeriodogramPlot.vue?vue&type=script&setup=true&lang=js"
export * from "./PeriodogramPlot.vue?vue&type=script&setup=true&lang=js"

import "./PeriodogramPlot.vue?vue&type=style&index=0&id=05c5425d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c5425d"]])

export default __exports__